import React from "react";
import { Container, Col, Row } from "bootstrap-4-react";
import { Link } from "react-router-dom";

function PrivacyDescriptions({ description }) {
  return ( 
      <section className="privacy-description-sec" id="privacy-description-sec">
        <Container fluid className="wrap">
          <Row>
            <Col md={12}>
              <div
                className="privacy-desc-div"
                dangerouslySetInnerHTML={{ __html: description }}
              />
            </Col>
          </Row>
        </Container>
      </section> 
  );
}

export default PrivacyDescriptions;
